import SectionSkeleton from "../../../../components/ui/SectionSkeleton"
import { Button, Typography } from "@mui/material"
import Images from "../../../../assets/js/Images"
import { Fragment, lazy, Suspense } from "react"
import { Link as NavLink } from "react-router-dom"

const TopBannerA = lazy(() => import("../../../../components/common/TopBannerA"))
const CtaSection = lazy(() => import("../../../../components/ui/CtaSection"))
const Workflow = lazy(() => import("./Workflow"))
const Coach = lazy(() => import("./Coach"))
const WhyUs = lazy(() => import("./WhyUs"))

function Coaching() {

  return (
    <Fragment>
      <Suspense fallback={<SectionSkeleton />}>
        <TopBannerA
          heading="One-on-One Coaching"
          currentPage="One-on-One Coaching"
          bannerImg={Images?.oneOnOne}
        />
      </Suspense>

      <Suspense fallback={<SectionSkeleton />}>
        <Coach />
      </Suspense>

      <Suspense fallback={<SectionSkeleton />}>
        <WhyUs />
      </Suspense>

      <Suspense fallback={<SectionSkeleton />}>
        <Workflow />
      </Suspense>

      <Suspense fallback={<SectionSkeleton />}>
        <CtaSection>
          <Typography
            variant="ctaNormal"
          >Start Your Personalized Journey
          </Typography>
          <Button
            variant="CtaButton"
            LinkComponent={NavLink}
            to="/webinars"
          >Book Your First Session
          </Button>
        </CtaSection>
      </Suspense>
    </Fragment>
  )
}

export default Coaching